type GoogleConfig = {
  ApiKey: string;
};

export const googleConfig: GoogleConfig = {
  ApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
};
